import { FormContainer, NotFoundContainer } from './Solar';
import { Navigate, Route, Routes } from 'react-router';

import { LoginCard } from '../ui';
import OnboardingLayout from '../ui/Layout/OnboardingLayout';

const SolarContainer = () => (
  <OnboardingLayout backgroundTint="yellow" hideSupport showNetZeroSupport>
    <LoginCard>
      <Routes>
        <Route index element={<FormContainer />} />
        <Route path="not-found" element={<NotFoundContainer />} />
        <Route path="*" element={<Navigate to="/solar/not-found" replace />} />
      </Routes>
    </LoginCard>
  </OnboardingLayout>
);

SolarContainer.propTypes = {};

export default SolarContainer;
